import { RouteConfig } from 'vue-router'
const JoinActivityPage = () => import('../activity/superHero/JoinActivity.vue')
const SuperHeroSpacePage = () => import('../activity/superHero/SuperHeroSpace.vue')

export const JoinSuperHeroRoute: RouteConfig = {
  path: '/join-super-hero',
  name: 'JoinSuperHero',
  component: JoinActivityPage,
  props: (route) => ({ ...route.query, ...route.params }),
}
export const SuperHeroSpaceRoute: RouteConfig = {
  path: '/super-hero-space',
  name: 'SuperHeroSpacePage',
  component: SuperHeroSpacePage,
  props: (route) => ({ ...route.query, ...route.params }),
}

export default [JoinSuperHeroRoute, SuperHeroSpaceRoute]
